"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.originalProductNameSelector = exports.productNameToBeAssociatedSelector = exports.productToastSelector = exports.isSavePromptVisibleSelector = exports.rowIndexToBeDeletedSelector = exports.productToBeDeletedSelector = exports.isProductListLoadingSelector = exports.isDeleteAlertDialogShownSelector = exports.productOptionsSelector = exports.productTableRowsSelector = void 0;
const productTableRowsSelector = (state) => {
    return state.products.products;
};
exports.productTableRowsSelector = productTableRowsSelector;
const productOptionsSelector = (state) => {
    return state.products.products.map((product) => {
        return {
            label: product.name,
            value: product.id,
        };
    });
};
exports.productOptionsSelector = productOptionsSelector;
const isDeleteAlertDialogShownSelector = (state) => {
    return state.products.isDeleteAlertDialogShown;
};
exports.isDeleteAlertDialogShownSelector = isDeleteAlertDialogShownSelector;
const isProductListLoadingSelector = (state) => {
    return state.products.isProductListLoading;
};
exports.isProductListLoadingSelector = isProductListLoadingSelector;
const productToBeDeletedSelector = (state) => {
    return state.products.productToBeDeleted;
};
exports.productToBeDeletedSelector = productToBeDeletedSelector;
const rowIndexToBeDeletedSelector = (state) => {
    return state.products.rowIndexToBeDeleted;
};
exports.rowIndexToBeDeletedSelector = rowIndexToBeDeletedSelector;
const isSavePromptVisibleSelector = (state) => {
    return state.products.isSavePromptVisible;
};
exports.isSavePromptVisibleSelector = isSavePromptVisibleSelector;
const productToastSelector = (state) => {
    return state.products.productToastStatus;
};
exports.productToastSelector = productToastSelector;
const productNameToBeAssociatedSelector = (state) => {
    return state.products.productNameToBeAssociated;
};
exports.productNameToBeAssociatedSelector = productNameToBeAssociatedSelector;
const originalProductNameSelector = (state) => {
    return state.products.originalAssociatedProductName;
};
exports.originalProductNameSelector = originalProductNameSelector;
